import MenuComponent from '@/components/MenuComponent'

export default {
  components: {
    MenuComponent
  }
}
